import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 44 44"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5.499 20.604c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15ZM34.87 34.368l8.635 8.636" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "20.5",
  cy: "20.5",
  r: "19.75"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M14.503 18.987a.393.393 0 1 1 0 .787.393.393 0 0 1 0-.787M27.872 18.987a.393.393 0 1 1 0 .786.393.393 0 0 1 0-.786M15.3 26.85a7.078 7.078 0 0 1 11.773 0" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }